import React, { Component} from 'react';

import get from 'lodash/get';

import Text from "ui/Text";
import documentIcon from 'assets/document.png'
import { FileSaveSubject } from "shared/FileSaveSubject";
import { ControlPassSubject } from 'shared/ControlPassSubject';
import Auth from 'shared/Auth';

class Input extends Component {
  constructor(){
    super();

    this.state = {
      hideFile: true,
      viewFile: 'View Current File',
      uploadPrompt: 'Upload New File'
    }
  }

  componentDidMount(){
    if (get(Auth.getLanguage(), 'local_locale') === 'fr') {
      this.setState({
        viewFile: 'Voir document',
        uploadPrompt: 'Telecharger un autre fichier'
      });
    }
  }

  onRadioChange = (ev) => {
    let fieldResponses = {}
    
    fieldResponses[this.props.fieldId] = ev.target.value;

    ControlPassSubject.next({ field: fieldResponses, controlType: 'radio' });
  }

  fileUpload = (ev) => {
    FileSaveSubject.next({ fileItem: ev.target.files[0], fieldId: this.props.fieldId});

    // if (this.files[0].size > 307200) {
    //   alert("File is too big!");
    //   this.value = "";
    // };
  }

  toggleUploader = () => {
    this.setState({
      hideFile: false
    });
  }

  render() {
    let inputField;

    const { nature, itemValue, nameVal, title, checked, onChange, response } = this.props;

    // Monkey patch to avoid nexted objects making it through.
    let getKeys = typeof(response) === "object" && Object.keys(response || {});

    let finalResponse = getKeys ? get(response || {}, getKeys[0]) : response;

    switch (nature) {
      case "file":
        inputField = response ? (
          <div className="input-file-upload">
            <input
              name={nameVal}
              accept=".pdf, .doc, .docx"
              type="file"
              onChange={this.fileUpload}
              className={`input-field ${this.state.hideFile ?  'hidden' : ''}`}
            />
            <a href={response} className={`file-link ${this.state.hideFile ?  '' : 'hidden'}`} target="_blank">
              <img src={documentIcon} alt="Document Icon" className="icon"/>{this.state.viewFile}</a>
            <a className={`cancel-btn ${this.state.hideFile ? '' : 'hidden'}`} onClick={this.toggleUploader}>
              {
                this.state.hideFile ? this.state.uploadPrompt : 'Cancel'
              }
            </a>
          </div>
        ) :  (
          <div className="input-file-upload">
            <input
              name={nameVal}
              accept=".pdf,.jpg,.jpeg"
              type="file"
              onChange={this.fileUpload}
              className={`input-field`}
            />
          </div>
        );
        break;
      case "radio":
        inputField = (
          <div className="flex align-items-center" tabIndex="1">
            <label
              className="flex align-items-center input-radio"
              htmlFor={`${itemValue}-${nameVal}`}>
              <Text type="small" modifiers="uppercase">
                {title || itemValue}
              </Text>
              <input
                type="radio"
                name={nameVal}
                value={itemValue}
                id={`${itemValue}-${nameVal}`}
                defaultChecked={itemValue === finalResponse}
                onChange={this.onRadioChange}
                className={`input-field`}
              />
              <span className="checkmark" />
            </label>
          </div>
        );
        break;
      case "checkbox":
        inputField = (
          <div className="flex align-items-center">
            <label
              className="flex align-items-center input-checkbox"
              htmlFor={`${itemValue}-${nameVal}`}
							tabIndex="1">
              <Text type="small" modifiers="inline">
                {title || itemValue}
              </Text>
              <input
                type="checkbox"
                checked={checked}
                onChange={() => onChange()}
                id={`${itemValue}-${nameVal}`}
                value={itemValue || ''}
                className={`input-field`}
              />
              <span className="checkmark" />
            </label>
          </div>
        );
        break;
      case "textarea":
        inputField = <textarea defaultValue={finalResponse} className={`input-field`} />;
        break;
      default:
        inputField = (
          <div className="input-field">
            {title ? (
              <label htmlFor={`${itemValue}-${nameVal}`}>
                <Text type="small" modifiers="inline">
                  {title}
                </Text>
              </label>
            ) : null}
            <input
              type={nature || "text"}
              id={`${itemValue}-${nameVal}`}
              name={nameVal}
              maxLength="250"
              defaultValue={finalResponse}
              className={`input-field solo-field`}
            />
          </div>
        );
        break;
    }

    return inputField;
  }
};

export default Input;


// WEBPACK FOOTER //
// ./src/ui/Input.js